import { render } from "./LicenseLabel.vue?vue&type=template&id=56d233a8&ts=true"
import script from "./LicenseLabel.vue?vue&type=script&lang=ts"
export * from "./LicenseLabel.vue?vue&type=script&lang=ts"

import "./LicenseLabel.vue?vue&type=style&index=0&id=56d233a8&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__